const carouselItems = [
  {
    title: '热门新片速递',
    desc: '每周精选10部最新上线影片，覆盖海内外热门资源，让您第一时间看到最新大片。',
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20movie%20scene%20with%20dramatic%20lighting%2C%20film%20clapperboard%20and%20golden%20spotlight%2C%20warm%20theater%20atmosphere%2C%20artistic%20movie%20production%20concept%2C%20deep%20red%20and%20gold%20color%20palette%2C%20elegant%20entertainment%20photography%20with%20soft%20shadows&width=800&height=500&seq=carousel-01-movie&orientation=landscape',
    alt: '91影视看片下载 - 热门新片速递',
    tag: '最新上线',
  },
  {
    title: '高分经典重温',
    desc: '豆瓣8分以上经典影视合集，从《肖申克的救赎》到《霸王别姬》，百看不厌的必看佳作。',
    img: 'https://readdy.ai/api/search-image?query=Classic%20movie%20collection%20aesthetic%20with%20vintage%20film%20posters%20and%20warm%20lighting%2C%20nostalgic%20cinema%20atmosphere%2C%20golden%20age%20of%20film%20concept%2C%20rich%20burgundy%20and%20gold%20tones%2C%20elegant%20retro%20entertainment%20visual%2C%20soft%20theater%20glow&width=800&height=500&seq=carousel-02-classic&orientation=landscape',
    alt: '91影视看片下载 - 高分经典重温',
    tag: '经典回顾',
  },
  {
    title: '天美麻花专区',
    desc: '天美麻花星空影视独家内容一站式观看，优先更新，品质保障，畅享专属观影体验。',
    img: 'https://readdy.ai/api/search-image?query=Premium%20cinema%20experience%20with%20golden%20starry%20night%20sky%20and%20movie%20screen%2C%20luxurious%20red%20velvet%20curtains%2C%20sparkling%20stars%20and%20film%20elements%2C%20elegant%20VIP%20theater%20concept%2C%20warm%20ambient%20lighting%2C%20sophisticated%20entertainment%20visual&width=800&height=500&seq=carousel-03-tianmei&orientation=landscape',
    alt: '天美麻花星空影视免费观看 - 天美麻花专区',
    tag: '独家内容',
  },
  {
    title: '周末追剧指南',
    desc: '周末必看剧集一次推荐，从热门韩剧到国产良心剧，宅家也能看遍全网好剧。',
    img: 'https://readdy.ai/api/search-image?query=Cozy%20weekend%20binge%20watching%20scene%20with%20warm%20living%20room%20ambiance%2C%20soft%20blanket%20and%20glowing%20screen%2C%20comfortable%20entertainment%20lifestyle%20concept%2C%20warm%20golden%20and%20amber%20lighting%2C%20relaxed%20cinematic%20atmosphere%2C%20home%20theater%20aesthetic&width=800&height=500&seq=carousel-04-weekend&orientation=landscape',
    alt: '91影视看片下载 - 周末追剧指南',
    tag: '追剧推荐',
  },
  {
    title: '暑期档观影指南',
    desc: '2026暑期热门影片全收录，从院线大片到网络热播，炎炎夏日清凉追剧好选择。',
    img: 'https://readdy.ai/api/search-image?query=Summer%20movie%20theater%20vibe%20with%20bright%20warm%20sunlight%20through%20windows%2C%20popcorn%20and%20film%20reels%2C%20refreshing%20entertainment%20atmosphere%2C%20golden%20hour%20lighting%20on%20cinema%20elements%2C%20vibrant%20yet%20elegant%20summer%20movie%20concept%2C%20soft%20bokeh%20background&width=800&height=500&seq=carousel-05-summer&orientation=landscape',
    alt: '91影视看片下载 - 暑期档观影指南',
    tag: '季节专题',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-4 py-1.5 rounded-full bg-accent-100 text-accent-800 text-xs font-semibold tracking-wide mb-3 whitespace-nowrap">
            焦点专题
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
            精选影视专题推荐
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-2xl mx-auto">
            精心策划五大热门专题，涵盖新片、经典、独家内容与追剧指南
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {carouselItems.map((item, idx) => (
            <article
              key={idx}
              className={`group bg-background-50 rounded-xl overflow-hidden transition-all duration-300 cursor-pointer ${
                idx === 0 ? 'lg:col-span-2 lg:row-span-1' : ''
              }`}
            >
              <div className={`relative overflow-hidden ${idx === 0 ? 'aspect-[16/7] lg:aspect-[16/5]' : 'aspect-[16/10]'}`}>
                <img
                  src={item.img}
                  alt={item.alt}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                  onError={(e) => {
                    const el = e.currentTarget;
                    el.style.display = 'none';
                    (el.parentElement as HTMLElement).style.display = 'none';
                  }}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
                <span className="absolute top-3 left-3 px-3 py-1 rounded-full bg-accent-500 text-background-50 text-xs font-semibold whitespace-nowrap">
                  {item.tag}
                </span>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="font-heading text-lg md:text-xl font-bold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-foreground-600 text-sm leading-relaxed">{item.desc}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}